export default {
  companies: [],
  // Detalle de la carpeta de trabajo activa (incluye owner_available_credits).
  // Se refresca al cambiar de carpeta y tras cada acción que consume/libera firmas.
  currentCompany: null
}
